import styled from 'styled-components';
import { TypographyStyles, maxWidthPartial, media, spacing } from '@storefront/lib-global/stylings';

export const NoResultsContainer = styled.div`
  padding: ${spacing.S} 0;
  scroll-margin-top: calc(${spacing.XXXL} + ${spacing.XXXS});
  width: 100%;

  @media ${media.greaterThan('lg')} {
    padding: ${spacing.M} 0;
  }
`;

export const NoResultsFoundText = styled.h1`
  ${maxWidthPartial()}
  ${TypographyStyles.Headings.H5}
margin-bottom: ${spacing.XXXS};
  text-align: center;
`;

export const AdjustSearchText = styled.p`
  ${maxWidthPartial()}
  ${TypographyStyles.Body.Small.Regular}
margin-bottom: ${spacing.M};
  text-align: center;

  @media ${media.greaterThan('lg')} {
    margin-bottom: 60px;
  }
`;

export const CategoryHeading = styled.h2`
  ${TypographyStyles.Headings.H3}
  margin: 0 0 20px;
  padding: 0 ${spacing.S};
  text-align: left;
  text-transform: uppercase;

  @media ${media.greaterThan('lg')} {
    margin-bottom: ${spacing.M};
    padding: 0;
    text-align: center;
  }
`;
